export default {
    namespaced: true,
    state: {
        color: "error",
        mode: "",
        show: false,
        textSnackbar: "Failed",
        timeout: 6000,
        x: null,
        y: "top",
    },
    mutations: {
        SET_COLOR_SNACKBAR(state, color) {
            state.color = color;
        },
        SET_TEXT_SNACKBAR(state, text) {
            state.textSnackbar = text;
        },
        SET_SHOW_SNACKBAR(state, show) {
            state.show = show;
        },
    },
    getters: {
        color(state) {
            return state.color;
        },
        mode(state) {
            return state.mode;
        },
        show(state) {
            return state.show;
        },
        textSnackbar(state) {
            return state.textSnackbar;
        },
        timeout(state) {
            return state.timeout;
        },
        x(state) {
            return state.x;
        },
        y(state) {
            return state.y;
        }
    },
    actions: {
        showHandlerSnackbar({ commit }, { color, text, show }) {
            commit("SET_COLOR_SNACKBAR", color);
            commit("SET_TEXT_SNACKBAR", text);
            commit("SET_SHOW_SNACKBAR", show);
        }
    },
}
